import { AES, enc } from "crypto-js";
import GenericSearchBar from "@/shared/components/GenericSearchBar/GenericSearchBar.vue";
import { List, ObjList } from "@/shared/components/GenericSearchBar/model/List";
import ObservationModal from "@/shared/components/ObservationModal/ObservationModal.vue";
import {
  NAME_FINDERS,
  PANEL_INFO_CONSTANTS,
  SOCKET_TOPICS,
  STATE,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { Http } from "@status/codes";
import { AxiosError } from "axios";

import lodash from "lodash";
import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import Vuetify from "vuetify";
import ModalTemplate from "../../shared/components/ModalTemplate/ModalTemplate.vue";
import Snackbar from "../../shared/components/Snackbar/Snackbar";
import {
  COLLECTIONS_NAME,
  COMPONENT_NAME_MODAL,
  FORM_CONSTANTS,
  FORM_MESSAGES,
  LIST_DATA_EVENTS,
  SEARCH_FILTER
} from "../../shared/constants/FormConstants";
import { STYLE_CLASSES } from "../../shared/constants/StyleConstants";
import { Utils } from "../../shared/utils/utils";
import EditTemplateName from "../AvailabilityTemplate/components/EditTemplateName/EditTemplateName.vue";
import ViewTemplate from "../AvailabilityTemplate/components/ViewTemplate/ViewTemplate.vue";
import {
  AvailabilityTemplate,
  AvailabilityTemplateResponse
} from "../AvailabilityTemplate/models/AvailabilityTemplateModel";
import { AvailabilityTemplateService } from "../AvailabilityTemplate/services/AvailabilityTemplateService";
import { CAMPUS_ACCESS } from "../Campus/constants/CampusConstants";
import { CampusService } from "../Campus/services/CampusService";
import { Filter } from "../Dashboards/AdminDashboard/models/Filter";
import {
  SecondaryFilter,
  SecondaryFilterOptions
} from "../Dashboards/AdminDashboard/models/SecondaryFilter";
import { SERVICE_TEMPLATES_ACCESS } from "../ServiceTemplate/constants/ServiceTemplateConstants";
import { ServiceTemplateService } from "../ServiceTemplate/services/ServiceTemplateService";
import { SPACES_ACCESS } from "../Space/constants/SpaceConstants";
import { SpaceService } from "../Space/services/SpaceService";
import { USER_ACCESS } from "../User/constants/UserConstants";
import { UserService } from "../User/services/UserService";
import DetailConsulting from "./components/DetailConsulting/DetailConsulting.vue";
import OptionsModal from "./components/OptionsModal/OptionsModal.vue";
import SaveAvailability from "./components/SaveAvailability/SaveAvailability.vue";
import UpdateEvent from "./components/UpdateEvent/UpdateEvent.vue";
import {
  AVAILABILITY_CONSTANTS,
  AVAILABILITY_FILTERS_NAME,
  AVAILIABILITY_ACCESS,
  DEFAULT_SCROLL_TO_TIME,
  CONTEXT_PANEL_FILTERS_LIST,
  FILTERS_LIST,
  EVENTS_STATES
} from "./constants/AvailabilityConstants";
import { AvailabilityDate } from "./models/AvailabilityDate";
import { AvailabilityEvent } from "./models/AvailabilityEventModel";
import { AvailabilityFilterDetailed } from "./models/AvailabilityFilterDetailed.model";
import { AvailabilityModel } from "./models/AvailabilityModel";
import { AvailabilityOnCreateModel } from "./models/AvailabilityOnCreateModel";
import { EventPatients } from "./models/EventPatients.model";
import { EventRange } from "./models/EventRange.model";
import store from "@/store";
import { SearchContext } from "@/shared/models/SearchContext";
import { mapGetters } from "vuex";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import { AvailabilityTemplateFilter } from "../AvailabilityTemplate/models/AvailabilityTemplateFilterModel";
import { Perspective } from "./models/Perspective";
import { AvailabilityService } from "./services/AvailabilityService";

Vue.use(Vuetify);
@Component({
  name: "Availability",
  components: {
    ModalTemplate,
    SaveAvailability,
    UpdateEvent,
    DetailConsulting,
    ObservationModal,
    OptionsModal,
    EditTemplateName,
    ViewTemplate,
    GenericSearchBar
  },
  computed: {
    ...mapGetters({
      dataToMainView: "getDataToMainView"
    })
  }
})
export default class Availability extends Vue {
  @Inject() availabilityService!: AvailabilityService;
  @Inject() availabilityTemplateService!: AvailabilityTemplateService;
  @Inject() serviceTemplateService!: ServiceTemplateService;
  @Inject() campusService!: CampusService;
  @Inject() spaceService!: SpaceService;
  @Inject() userService!: UserService;

  dataToMainView!: MenuDataStructure;

  PAGE_START = FORM_CONSTANTS.BUTTON.PAGE_START;
  CANCEL_BUTTON = FORM_CONSTANTS.BUTTON.CANCEL;
  EDIT_BUTTON = FORM_CONSTANTS.BUTTON.EDIT;
  DELETE_BUTTON = FORM_CONSTANTS.BUTTON.DELETE;
  CLOSE_BUTTON = FORM_CONSTANTS.BUTTON.CLOSE;
  GOBACK_BUTTON = FORM_CONSTANTS.BUTTON.GO_BACK;
  TITLE = AVAILABILITY_CONSTANTS.TEXTS.TITLE;
  CREATE_BUTTON = AVAILABILITY_CONSTANTS.TEXTS.CREATE_BUTTON;
  UPLOAD_BUTTON = AVAILABILITY_CONSTANTS.TEXTS.UPLOAD_BUTTON;
  SPACES_RESERVED = AVAILABILITY_CONSTANTS.CONFIGURATIONS.SPACES_RESERVED;
  MORE_TEXT = AVAILABILITY_CONSTANTS.CONFIGURATIONS.MORE_TEXT;

  VIEW_TYPE = AVAILABILITY_CONSTANTS.CONFIGURATIONS.VIEW_TYPES[1].value;
  VIEW_TYPES = AVAILABILITY_CONSTANTS.CONFIGURATIONS.VIEW_TYPES;
  OVERLAP_MODE = AVAILABILITY_CONSTANTS.CONFIGURATIONS.OVERLAP_MODE;
  TODAY = AVAILABILITY_CONSTANTS.TEXTS.TODAY;
  LOCALE = AVAILABILITY_CONSTANTS.CONFIGURATIONS.LOCALE;
  SEARCH_AVAILABILITY_KEY = NAME_FINDERS.AVAILABILITY;
  FIRST_INTERVAL_VIEW =
    AVAILABILITY_CONSTANTS.CONFIGURATIONS.FIRST_INTERVAL_VIEW;
  VIEW_TYPE_DAY = AVAILABILITY_CONSTANTS.TEXTS.DAY;

  iconBtnClass = STYLE_CLASSES.ICON_BTN;
  cardClass = STYLE_CLASSES.CARD;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  primaryButtonClass = STYLE_CLASSES.PRIMARY_BTN;
  secondaryButtonClass = STYLE_CLASSES.SECONDARY_BTN;
  accentColor = STYLE_CLASSES.CHIP_COLOR.ACCENT;
  vSheetClass = STYLE_CLASSES.V_SHEET;
  cardStyle = STYLE_CLASSES.CARD_STYLE;

  filterItems: AvailabilityFilterDetailed = new AvailabilityFilterDetailed();

  selectObjectItem = SEARCH_FILTER.EMPTY_STATUS;

  idLists = AVAILABILITY_CONSTANTS.TEXTS.ID_LISTS;
  itemsOfSelect = AVAILABILITY_CONSTANTS.TEXTS.ITEMS_OF_SELECT;

  calendarValue = "";
  events: EventRange[] = [];
  allEvents: AvailabilityModel[] = [];

  showModalConfirmation = false;
  modalConfirmationText = "";
  modalConfirmationTitle = "";
  responsableModalFlag = false;
  responsablesToChangeFront: string[] = [];

  showModalSaveProp = false;
  showModalEditEvent = false;
  availabilityDateProp? = "";
  startTimeProp? = "";
  endTimeProp? = "";

  selectedEvent = {};
  selectedElement = null;
  seeDetails = false;

  dragToCreate = true;
  createEvent?: AvailabilityModel;
  createStart?: number;
  createdEventDragging = false;
  calendarPerspective: Perspective = new Perspective();

  currentAvailabilityItem: SecondaryFilterOptions = {} as SecondaryFilterOptions;
  viewTemplateSelected: AvailabilityTemplateResponse = {};
  allInfoCardsEvents: AvailabilityModel = {} as AvailabilityModel;
  allInfoEvents: Array<AvailabilityEvent> = [] as Array<AvailabilityEvent>;
  SelectDefaultvalue = "";
  selectedEventId = "";
  selectedRangeOfEventsKey = "";
  listAvailabilityTemplates: AvailabilityTemplateResponse[] = [];
  lastReference = "";

  dialogObservation = false;
  idDeleting = "";
  actionMode = "";
  idEditing = "";
  showOptionsModalDelete = false;
  showOptionsModalEdit = false;
  showEditAvailabilityName = false;
  showViewTemplate = false;
  optionsModalText = "";
  optionsModalTitle = "";
  tempAvailability?: AvailabilityModel;
  individual = AVAILABILITY_CONSTANTS.OPTION_MODAL.OPTION_LIST[0].value;
  isExtendEvent = false;
  calendarHasLoaded = false;
  COLOR_OPACITY = AVAILABILITY_CONSTANTS.CONFIGURATIONS.COLOR_OPACITY;
  filterArray: Filter[] = lodash.cloneDeep(FILTERS_LIST) as Filter[];
  filterPanelArray: Filter[] = lodash.cloneDeep(
    CONTEXT_PANEL_FILTERS_LIST
  ) as Filter[];
  filterPanel: AvailabilityTemplateFilter = {};
  listObj: ObjList = { name: "", list: [] };
  listOfAvailabilityTemplates: List[] = [];
  listOfNames: List[] = [];
  listOfServiceTemplates: List[] = [];
  listOfCampuses: List[] = [];
  listOfSpaces: List[] = [];
  listOfResponsables: List[] = [];
  listOfStatuses: List[] = [];
  listOfUsers: List[] = [];
  availabilityDefaultData: {} = {};
  OPERATIONS = [
    LIST_DATA_EVENTS.EDIT_DATA,
    LIST_DATA_EVENTS.VIEW_DATA,
    LIST_DATA_EVENTS.DELETE_DATA
  ];
  SHOW_EVENTS = AVAILABILITY_CONSTANTS.TEXTS.SHOW_EVENTS;
  EDIT_AVAILABILITY = AVAILABILITY_CONSTANTS.TEXTS.EDIT_AVAILABILITY;
  EDIT_EVENT = AVAILABILITY_CONSTANTS.TEXTS.EDIT_EVENT;
  hiddeEvents = true;
  rangeOfEventsData: EventPatients = {} as EventPatients;
  loadingData = false;
  isCreating = false;
  lastAvailabilityRef = "";
  keyWordAvailabiltyName = "";
  availabilityInfo: {
    spaces: string[];
    campuses: string[];
    responsables: string[];
  } = {
    spaces: [],
    campuses: [],
    responsables: []
  };
  totalEventsReservedLocal = 0;
  totalEventsLocal = 0;

  get totalEventsReserved() {
    return this.totalEventsReservedLocal;
  }

  get totalEvents() {
    return this.totalEventsLocal;
  }

  async mounted() {
    await this.loadConstantsUi();
    this.OPERATIONS = Utils.addExtraOperations(
      this.OPERATIONS,
      COLLECTIONS_NAME.AVAILABILITY
    );
    this.emitSearchInitializer();
    this.handleBreakpoint();
    this.initialCalendarScrollToTime();
    this.initListener();
  }
  initListener() {
    this.$socket.$subscribe(
      SOCKET_TOPICS.AVAILABILITY_CHANGED,
      this.processAvailabilityPayload
    );
  }

  processAvailabilityPayload(payload: string) {
    const payloadBytes = AES.decrypt(
      payload,
      process.env.VUE_APP_TOKEN_SECRET as string
    );
    const medicalData = payloadBytes.toString(enc.Utf8);
    const data: AvailabilityModel = JSON.parse(medicalData);
    const validate = this.validatesAvailability(data);
    if (validate) {
      this.mapNewAvailability(data);
    }
  }

  validatesAvailability(availability: AvailabilityModel) {
    const filter = this.filterItems;

    if (
      filter.name &&
      !filter.name?.includes(availability.availabilityTemplate!)
    ) {
      return false;
    }
    if (filter.status && !filter.status?.includes(availability.status)) {
      return false;
    }
    if (filter.campus && !filter.campus?.includes(availability.campus!)) {
      return false;
    }
    if (filter.space && !filter.space?.includes(availability.space!)) {
      return false;
    }
    if (filter.space && !filter.space?.includes(availability.space!)) {
      return false;
    }
    if (
      filter.service &&
      !filter.service.some(item =>
        (availability.serviceTemplate as string[]).includes(item)
      )
    ) {
      return false;
    }
    if (
      filter.responsable &&
      !filter.responsable.some(item =>
        (availability.responsable as string[]).includes(item)
      )
    ) {
      return false;
    }
    if (
      filter.filterDate &&
      filter.dateStart &&
      (availability.start as number) < filter.dateStart
    ) {
      return false;
    }
    if (
      filter.dateEnd &&
      filter.filterDate &&
      filter.dateEnd < (availability.end as number)
    ) {
      return false;
    }
    return true;
  }
  mapNewAvailability(availability: AvailabilityModel) {
    const events = availability.events;
    const eventRange: { [key: string]: EventRange } = {};
    events.forEach((event: AvailabilityEvent) => {
      const result = eventRange[`${event.start}-${event.end}`];
      const reserved =
        event.status == EVENTS_STATES.RESERVED
          ? (result?.reserved || 0) + 1
          : result?.reserved || 0;
      const locked = [
        EVENTS_STATES.BLOQUED,
        EVENTS_STATES.NOT_AVAILABLE
      ].includes(event.status)
        ? (result?.locked || 0) + 1
        : result?.locked || 0;
      const total = (result?.total || 0) + 1;

      const availableColor =
        (availability.color as string) != ""
          ? Utils.changeColorOpacity(
              availability.color as string,
              AVAILABILITY_CONSTANTS.CONFIGURATIONS.COLOR_OPACITY
            )
          : AVAILABILITY_CONSTANTS.COLORS.AVAILABLE;
      const reservedColor =
        (availability.color as string) != ""
          ? (availability.color as string)
          : AVAILABILITY_CONSTANTS.COLORS.RESERVED;
      let newColor = availableColor;
      if (reserved > 0 && event.medicalAppointments) {
        newColor = event.medicalAppointments.eventColor
          ? event.medicalAppointments.eventColor
          : reservedColor;
      }
      if (
        locked > 0 ||
        availability.status === AVAILABILITY_CONSTANTS.TEXTS.LOCKED
      ) {
        newColor = AVAILABILITY_CONSTANTS.COLORS.LOCKED;
      }

      eventRange[`${event.start}-${event.end}`] = {
        color: newColor,
        start: event.start,
        end: event.end,
        formattedDate: `${Utils.formatDateFromNumber(
          event.start
        )} - ${Utils.formatDateFromNumber(event.end)}`,
        name: availability.name || event.name,
        patientName: event.medicalAppointments.patient || "",
        rangeEventsId: `${event.start}-${event.end}`,
        reserved,
        locked,
        total: availability.capacity || total,
        timed: true,
        _key: availability.id!
      };
    });

    this.events = this.events.filter(
      event =>
        !Object.keys(eventRange).includes(event.rangeEventsId) &&
        event._key != availability.id
    );

    this.events = [...this.events, ...Object.values(eventRange)];
  }

  initialCalendarScrollToTime() {
    if (this.$refs && this.$refs.calendar) {
      const scroll = this.$refs.calendar as Vue & {
        scrollToTime: (data: string) => void;
      };
      if (scroll.scrollToTime) {
        scroll.scrollToTime(DEFAULT_SCROLL_TO_TIME);
      }
    }
  }

  @Watch("$vuetify.breakpoint.name")
  handleBreakpoint() {
    const dayType = this.VIEW_TYPES.find(
      viewType => viewType.value === AVAILABILITY_CONSTANTS.TEXTS.DAY
    );

    if (this.$vuetify.breakpoint.smAndDown && dayType !== undefined) {
      this.VIEW_TYPE = dayType.value;
    }
  }

  async getEvents(calendarPerspective: Perspective = new Perspective()) {
    this.calendarPerspective = calendarPerspective;
    this.events = [];
    if (AvailabilityFilterDetailed.isEmpty(this.filterItems)) {
      return;
    }
    this.loadingData = true;
    this.filterItems.start = this.calendarPerspective.start.date;
    this.filterItems.end = this.calendarPerspective.end.date;

    const filters = { ...this.filterItems };

    if (filters.start == filters.end && !filters.name) {
      delete filters.name;
      delete filters.state;
    }

    const response = await this.getFilteredEventsPrivate(filters);
    if (response !== undefined) {
      this.events = await this.getMappedEvents(response);
    } else {
      this.events = [];
    }
    this.loadingData = false;
    this.calendarHasLoaded = true;
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  async getFilteredEvents(data: any) {
    let changedAvailabilityTemplate = false;
    if (
      (!this.filterItems.name && data.name) ||
      (this.filterItems.name &&
        data.name &&
        this.filterItems.name != data.name[0])
    ) {
      changedAvailabilityTemplate = true;
    }
    delete data["mainFilterKey"];
    this.filterItems = { ...data };

    if (AvailabilityFilterDetailed.isEmpty(this.filterItems)) {
      this.resetFilters();
      Snackbar.popWarning(AVAILABILITY_CONSTANTS.SNACKBAR.NO_CHOSEN_FILTERS);
    } else {
      this.loadingData = true;
      this.filterItems.start = this.calendarPerspective.start.date;
      this.filterItems.end = this.calendarPerspective.end.date;

      const response = await this.getFilteredEventsPrivate(this.filterItems);
      if (response !== undefined) {
        if (changedAvailabilityTemplate && this.filterItems.name) {
          await this.getServicesByAvailabilityId(this.filterItems.name[0]);
          this.availabilityInfo = {
            spaces: response.flatMap((e: any) => e.space),
            campuses: response.flatMap((e: any) => e.campus),
            responsables: response.flatMap((e: any) => e.responsible)
          };
          await this.getCampus();
          await this.getSpaces();
          await this.getResponsables();
        }
        this.events = await this.getMappedEvents(response);
      } else {
        if (changedAvailabilityTemplate) {
          this.resetFilters();
        }
        this.events = [];
      }
      this.loadingData = false;
    }
  }

  async handleSearchBarInfo(
    data: { type: string; key: string },
    /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
    parameter: any
  ) {
    const getData: {
      /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
      [list: string]: { [x: string]: (parameter: any) => Promise<void> };
    } = {
      availability: {
        [AVAILABILITY_FILTERS_NAME.NAME]: async () => {
          await this.getAvailabilityTemplates();
        },
        [AVAILABILITY_FILTERS_NAME.SERVICE]: async () => {
          if (this.filterItems.name) {
            await this.getServicesByAvailabilityId(this.filterItems.name[0]);
          } else {
            await this.getServiceTemplates();
          }
        },
        [AVAILABILITY_FILTERS_NAME.CAMPUS]: async () => {
          if (!this.filterItems.name) {
            await this.getCampus();
          }
        },
        [AVAILABILITY_FILTERS_NAME.SPACE]: async () => {
          if (!this.filterItems.name) {
            await this.getSpaces();
          }
        },
        [AVAILABILITY_FILTERS_NAME.RESPONSABLE]: async () => {
          if (!this.filterItems.name) {
            await this.getResponsables();
          }
        }
      }
    };
    const typeGetData = getData[data.type];
    const typeData =
      typeGetData !== undefined ? typeGetData[data.key] : undefined;

    if (typeData !== undefined) {
      await typeData(parameter);
    }
  }

  async getFilteredEventsPrivate(
    filters: AvailabilityFilterDetailed
  ): Promise<Array<AvailabilityModel> | void> {
    try {
      const requestDependenciesData = await this.availabilityService.getAvailabilityByDetailedFilter(
        filters
      );

      if (
        requestDependenciesData.code === Http.Found &&
        requestDependenciesData.data !== undefined
      ) {
        return requestDependenciesData.data;
      } else {
        return;
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + AVAILIABILITY_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      return;
    }
  }

  async cardsInfoEvent(key: string, start: number, end: number) {
    try {
      this.reboot();
      const rangeOfEventsResponse = await this.availabilityService.getRangeOfEventsData(
        key,
        start,
        end
      );
      if (
        rangeOfEventsResponse.code === Http.Found &&
        rangeOfEventsResponse.data
      ) {
        const { data: infoCard } = rangeOfEventsResponse;
        if (
          rangeOfEventsResponse &&
          Object.keys(rangeOfEventsResponse).length > 0
        ) {
          this.rangeOfEventsData = infoCard;
        }
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + AVAILIABILITY_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  reboot() {
    this.rangeOfEventsData = {} as EventPatients;
    this.SelectDefaultvalue = AVAILABILITY_CONSTANTS.TEXTS.REBOOT_OPTION_VALUE;
    this.allInfoCardsEvents = {} as AvailabilityModel;
    this.allInfoEvents = [] as Array<AvailabilityEvent>;
  }

  getEventColor(event: AvailabilityModel) {
    if (event.color) {
      return event.color;
    }
    if (event.status === AVAILABILITY_CONSTANTS.TEXTS.AVAILABLE) {
      return AVAILABILITY_CONSTANTS.COLORS.GREEN;
    } else if (event.status === AVAILABILITY_CONSTANTS.TEXTS.LOCKED) {
      return AVAILABILITY_CONSTANTS.COLORS.GREY;
    } else {
      return AVAILABILITY_CONSTANTS.COLORS.PURPLE;
    }
  }

  goToStart(id: string) {
    Utils.scrollToElement(id, this);
  }

  addAvailability(createdDragging: boolean) {
    this.createdEventDragging = createdDragging;
    if (createdDragging) {
      const startDate = new Date(this.createEvent?.start as number);
      const endDate = new Date(this.createEvent?.end as number);
      this.availabilityDateProp = this.transformDate(startDate);
      this.startTimeProp = this.transformTime(startDate.toTimeString());
      this.endTimeProp = this.transformTime(endDate.toTimeString());
      this.availabilityDefaultData = this.buildAvailabilityFromFilters();
    }
    if (!this.isExtendEvent) {
      this.idEditing = "";
    }
    this.showModalSaveProp = true;
  }

  transformDate(date: Date): string {
    let dateISO8601: string = date.getFullYear().toString();
    dateISO8601 += "-";
    dateISO8601 +=
      date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
    dateISO8601 += "-";
    dateISO8601 += date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
    return dateISO8601;
  }

  transformTime(time: string): string {
    const splittedTime = time.split(AVAILABILITY_CONSTANTS.SPLITTERS.TIME);
    return splittedTime[0];
  }

  async editAvailability(id: string) {
    this.modalConfirmationText = FORM_MESSAGES.SAVE_MODAL.TITLE;
    this.modalConfirmationTitle = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
    this.idEditing = id;
    this.showModalSaveProp = true;
  }
  async editEvent() {
    this.showModalEditEvent = true;
  }

  cancel() {
    this.modalConfirmationTitle = FORM_MESSAGES.CANCEL_MODAL.TITLE;
    this.modalConfirmationText = FORM_MESSAGES.CANCEL_MODAL.MESSAGE;
    this.showModalConfirmation = true;
  }

  async handleModalAccept() {
    this.showModalConfirmation = false;
    if (this.modalConfirmationTitle === FORM_MESSAGES.CANCEL_MODAL.TITLE) {
      this.$router.go(-1);
    } else if (
      this.modalConfirmationTitle === FORM_MESSAGES.DELETE_MODAL.TITLE
    ) {
      await this.disableAvailability(this.idDeleting, this.individual);
      this.seeDetails = false;
    }
  }

  handleModalCancel() {
    this.showModalConfirmation = false;
  }

  async handleSaveModalAccept(
    availability: AvailabilityModel,
    action: string,
    oldAvailabilityRecurrent: boolean
  ) {
    if (action === AVAILABILITY_CONSTANTS.EVENTS.CREATE_MODAL) {
      this.isCreating = true;
      this.availabilityDateProp = "";
      this.startTimeProp = "";
      this.endTimeProp = "";
      if (this.createdEventDragging) {
        this.allEvents[this.allEvents.length - 1].name = availability.name;
        this.allEvents[this.allEvents.length - 1].start = availability.start;
        this.allEvents[this.allEvents.length - 1].end = availability.end;
        this.allEvents[this.allEvents.length - 1].status = availability.status;
      } else {
        this.generateEvent(
          availability.name as string,
          (availability.start as number).valueOf(),
          (availability.end as number).valueOf(),
          availability.status
        );
      }
      availability.serviceTemplate = (availability.serviceTemplate as any[])?.map(
        serviceTmp => serviceTmp.id ?? (serviceTmp as string)
      );
      try {
        const responseData = await this.availabilityService.createAvailability(
          availability
        );
        this.isCreating = false;
        if (responseData.code === Http.Ok) {
          Snackbar.popSuccess(responseData.message);
          this.showModalSaveProp = false;
          this.events = [];
          this.allEvents = [];
          this.rangeOfEventsData = new EventPatients();
          this.changeOfEvent();
          await this.getEvents(this.calendarPerspective);
          this.selectedEventId = "";
          this.selectedEvent = {};
          this.seeDetails = false;
        } else if (responseData.code === Http.Found) {
          Snackbar.popError(responseData.message);
          this.responsableModalFlag = !this.responsableModalFlag;
          this.showModalSaveProp = true;
          if (
            ((responseData.data as unknown) as AvailabilityModel)
              .listOfIdsResponsable
          ) {
            this.responsablesToChangeFront =
              ((responseData.data as unknown) as AvailabilityModel)
                .listOfIdsResponsable || [];
          }
        } else {
          Snackbar.popError(responseData.message);
          this.allEvents.pop();
          this.getEvents(this.calendarPerspective);
        }
      } catch (error) {
        if ((error as AxiosError).response?.status == Http.Forbidden)
          Snackbar.popError(
            FORM_MESSAGES.FORBIDDEN_REQUEST + AVAILIABILITY_ACCESS.POST
          );
        else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
        this.allEvents.pop();
      }
    } else {
      if (oldAvailabilityRecurrent) {
        this.tempAvailability = availability;
        this.optionsModalTitle = AVAILABILITY_CONSTANTS.OPTION_MODAL.TITLE_EDIT;
        this.optionsModalText = AVAILABILITY_CONSTANTS.OPTION_MODAL.TEXT_EDIT;
        this.showOptionsModalEdit = true;
      } else {
        this.isCreating = true;
        this.availabilityDateProp = "";
        this.startTimeProp = "";
        this.endTimeProp = "";
        try {
          const responseData = await this.availabilityService.updateAvailabilityByIdWithOption(
            this.idEditing,
            availability,
            this.individual
          );
          this.isCreating = false;
          if (responseData.code === Http.Ok) {
            Snackbar.popSuccess(responseData.message);
            this.showModalSaveProp = false;
            this.events = [];
            this.allEvents = [];
            this.rangeOfEventsData = new EventPatients();
            this.changeOfEvent();
            await this.getEvents(this.calendarPerspective);
            this.selectedEventId = "";
            this.idEditing = "";
            this.selectedEvent = {};
            this.seeDetails = false;
          } else {
            Snackbar.popError(responseData.message, 0);
          }
        } catch (error) {
          if ((error as AxiosError).response?.status == Http.Forbidden)
            Snackbar.popError(
              FORM_MESSAGES.FORBIDDEN_REQUEST + AVAILIABILITY_ACCESS.PUT
            );
          else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
        }
      }
    }
    this.createdEventDragging = false;
    this.isExtendEvent = false;
  }

  generateEvent(name: string, start: number, end: number, status: string) {
    this.createEvent = {
      name: name,
      status: status,
      start: start,
      end: end,
      timed: true,
      index: this.allEvents.length
    };

    this.allEvents.push(this.createEvent);
  }

  handleSaveModalCancel() {
    this.resetDialogFields();
    if (this.createdEventDragging && !this.isExtendEvent) {
      this.createdEventDragging = false;
      this.allEvents.pop();
    }
    this.getEvents(this.calendarPerspective);
    this.isExtendEvent = false;
    this.idEditing = "";
    this.showModalEditEvent = false;
  }

  goToCurrentDate() {
    this.calendarValue = "";
  }

  capitalizeMonths(monthName: string): string {
    if (monthName) {
      const splittedName = monthName.split(
        AVAILABILITY_CONSTANTS.SPLITTERS.MONTH
      );

      for (let i = 0; i < splittedName.length; i++) {
        splittedName[i] =
          splittedName[i].charAt(0).toUpperCase() + splittedName[i].slice(1);
      }

      return splittedName.join(AVAILABILITY_CONSTANTS.SPLITTERS.MONTH);
    } else {
      return "";
    }
  }

  viewDay(date: AvailabilityDate) {
    const dayType = this.VIEW_TYPES.find(
      viewType => viewType.value === AVAILABILITY_CONSTANTS.TEXTS.DAY
    );
    if (dayType !== undefined) {
      this.VIEW_TYPE = dayType.value;
      this.calendarValue = date.date;
    }
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  showEvent(nativeEvent: any) {
    this.selectedEvent = {};
    this.selectedEventId = "";
    this.selectedElement = null;
    const openDetail = () => {
      this.selectedEvent = nativeEvent.event;
      this.selectedElement = nativeEvent.nativeEvent.target;
      this.selectedEventId = nativeEvent.event._key;
      this.selectedRangeOfEventsKey = nativeEvent.event.rangeEventsId;
      requestAnimationFrame(() =>
        requestAnimationFrame(() => (this.seeDetails = true))
      );
    };

    this.hiddeEvents = true;
    openDetail();
    nativeEvent.nativeEvent.stopPropagation();
  }

  @Watch("selectedEventId", { deep: true })
  changeOfEvent() {
    if (this.selectedEventId) {
      const splittedRangeKey = this.selectedRangeOfEventsKey.split("-");
      const start = parseInt(splittedRangeKey[0]);
      const end = parseInt(splittedRangeKey[1]);
      this.cardsInfoEvent(this.selectedEventId, start, end);
    }
  }

  @Watch("selectedRangeOfEventsKey")
  chageOfRangeOfEvents() {
    if (this.selectedRangeOfEventsKey) {
      this.changeOfEvent();
    }
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  startDrag(parameter: any) {
    if (parameter.event && parameter.timed) {
      this.dragToCreate = false;
    } else {
      this.dragToCreate = true;
    }
  }

  dragTime(tms: AvailabilityDate) {
    if (this.dragToCreate && !this.seeDetails) {
      const mouse = this.toTime(tms);

      this.createStart = this.roundTime(mouse);
      this.generateEvent(
        `Event #${this.allEvents.length}`,
        this.createStart,
        this.createStart,
        ""
      );
    }
  }

  mouseMove(tms: AvailabilityDate) {
    const mouse = this.toTime(tms);
    if (this.createEvent && this.createStart !== undefined) {
      const mouseRounded = this.roundTime(mouse, false);
      const min = Math.min(mouseRounded, this.createStart);
      const max = Math.max(mouseRounded, this.createStart);

      this.createEvent.start = min;
      this.createEvent.end = max;
    }
  }

  endDrag() {
    if (
      this.dragToCreate &&
      !this.seeDetails &&
      this.createEvent &&
      this.createStart !== undefined
    ) {
      if (AvailabilityFilterDetailed.hasMultiFilters(this.filterItems)) {
        Snackbar.popWarning(
          AVAILABILITY_CONSTANTS.SNACKBAR
            .NO_AVAILABILITY_CREATION_DUE_MULTIFILTERS
        );
      } else if (AvailabilityFilterDetailed.isEmpty(this.filterItems)) {
        Snackbar.popWarning(
          AVAILABILITY_CONSTANTS.SNACKBAR.AT_LEAST_ONE_FILTER_TO_CREATE
        );
      } else {
        this.addAvailability(true);
      }
    }
    this.resetDrag();
  }

  cancelDrag() {
    if (this.createEvent && this.createStart !== undefined) {
      const i = this.allEvents.indexOf(this.createEvent);
      if (i !== -1) {
        this.allEvents.splice(i, 1);
      }
    }

    this.resetDrag();
  }

  resetDrag() {
    this.createEvent = undefined;
    this.createStart = undefined;
    this.dragToCreate = true;
  }

  roundTime(time: number, down = true) {
    let roundTo;
    if (this.isExtendEvent) {
      roundTo = this.createEvent?.duration as number;
    } else {
      roundTo = 15;
    }
    const roundDownTime = roundTo * 60 * 1000;

    return down
      ? time - (time % roundDownTime)
      : time + (roundDownTime - (time % roundDownTime));
  }

  toTime(tms: AvailabilityDate) {
    return new Date(
      tms.year,
      tms.month - 1,
      tms.day,
      tms.hour,
      tms.minute
    ).getTime();
  }

  regInsensitive(inputText: string) {
    return inputText
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  }

  resetDialogFields() {
    this.showModalSaveProp = false;
    this.availabilityDateProp = "";
    this.startTimeProp = "";
    this.endTimeProp = "";
  }

  async disableAvailability(id: string, option: string) {
    try {
      const responseData = await this.availabilityService.deleteAvailabilityByIdWithOption(
        id,
        option
      );

      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        this.getEvents(this.calendarPerspective);
      } else {
        Snackbar.popInfo(responseData.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + AVAILIABILITY_ACCESS.DELETE
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async deleteAvailability(itemId: string) {
    let isRecurrent = false;
    this.idDeleting = itemId;

    try {
      const res = await this.availabilityService.getAvailabilityDataEditById(
        this.idDeleting
      );

      if (res.code === Http.Found && res.data) {
        isRecurrent = res.data.recurrent as boolean;
        if (isRecurrent) {
          this.optionsModalTitle =
            AVAILABILITY_CONSTANTS.OPTION_MODAL.TITLE_DELETE;
          this.optionsModalText =
            AVAILABILITY_CONSTANTS.OPTION_MODAL.TEXT_DELETE;
          this.showOptionsModalDelete = true;
        } else {
          this.modalConfirmationTitle = FORM_MESSAGES.DELETE_MODAL.TITLE;
          this.modalConfirmationText = FORM_MESSAGES.DELETE_MODAL.MESSAGE;
          this.showModalConfirmation = true;
        }
      } else {
        Snackbar.popInfo(res.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + AVAILIABILITY_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  handleOptionsModalDeleteCancel() {
    this.idDeleting = "";
    this.showOptionsModalDelete = false;
  }

  async handleOptionsModalDeleteAccept(option: string) {
    this.showOptionsModalDelete = false;
    this.isCreating = true;
    await this.disableAvailability(this.idDeleting, option);
    this.isCreating = false;
    this.events = [];
    this.allEvents = [];
    this.rangeOfEventsData = new EventPatients();
    this.changeOfEvent();
    await this.getEvents(this.calendarPerspective);
    this.selectedEventId = "";
    this.selectedEvent = {};
    this.seeDetails = false;
  }

  handleOptionsModalEditCancel() {
    this.idDeleting = "";
    this.showOptionsModalEdit = false;
  }

  async handleOptionsModalEditAccept(option: string) {
    this.showOptionsModalEdit = false;
    this.isCreating = true;
    try {
      const responseData = await this.availabilityService.updateAvailabilityByIdWithOption(
        this.idEditing,
        this.tempAvailability as AvailabilityModel,
        option
      );
      this.isCreating = false;
      if (responseData.code === Http.Ok) {
        this.showModalSaveProp = false;
        Snackbar.popSuccess(responseData.message);
        this.events = [];
        this.allEvents = [];
        this.rangeOfEventsData = new EventPatients();
        this.changeOfEvent();
        await this.getEvents(this.calendarPerspective);
        this.selectedEventId = "";
        this.selectedEvent = {};
        this.seeDetails = false;
      } else {
        Snackbar.popError(responseData.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + AVAILIABILITY_ACCESS.PUT
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      this.cancelDrag();
    }
    this.handleSaveModalCancel();
    this.idEditing = "";
  }

  closeSaveModal() {
    this.showModalSaveProp = false;
    this.isExtendEvent = false;
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  extendBottom(event: any) {
    this.createEvent = event;
    this.createStart = event.start;
    this.idEditing = event._key;
    this.isExtendEvent = true;
  }

  getMappedEvents(
    availabilitiesEvents: Array<AvailabilityModel>
  ): EventRange[] {
    const occurrences: EventRange[] = [];

    availabilitiesEvents.forEach((availability: AvailabilityModel) => {
      Object.keys(availability.events as {}).forEach(
        (rangeEventsId: string) => {
          const splittedDateRange = rangeEventsId.split("-");
          const startDate: number = parseInt(splittedDateRange[0]);
          const endDate: number = parseInt(splittedDateRange[1]);
          const event = availability.events[rangeEventsId];
          const formattedDate = `${Utils.formatDateFromNumber(
            startDate
          )} - ${Utils.formatDateFromNumber(endDate)}`;

          const availableColor =
            (availability.color as string) != ""
              ? Utils.changeColorOpacity(
                  availability.color as string,
                  AVAILABILITY_CONSTANTS.CONFIGURATIONS.COLOR_OPACITY
                )
              : AVAILABILITY_CONSTANTS.COLORS.AVAILABLE;
          const reservedColor =
            (availability.color as string) != ""
              ? (availability.color as string)
              : AVAILABILITY_CONSTANTS.COLORS.RESERVED;
          let newColor = availableColor;
          if (event.reserved > 0 && event.medicalAppointment) {
            newColor = event.medicalAppointment.eventColor
              ? event.medicalAppointment.eventColor
              : reservedColor;
          }
          if (
            event.locked > 0 ||
            availability.status === AVAILABILITY_CONSTANTS.TEXTS.LOCKED
          ) {
            newColor = AVAILABILITY_CONSTANTS.COLORS.LOCKED;
          }

          occurrences.push({
            _key: availability.id as string,
            name: availability.name as string,
            start: startDate,
            end: endDate,
            timed: true,
            rangeEventsId,
            color: newColor,
            formattedDate,
            total: event.total,
            reserved: event.reserved,
            locked: event.locked,
            patientName: event.medicalAppointment?.patient?.name
          });
        }
      );
    });

    return occurrences;
  }

  setList(name: string, list: List[]) {
    this.listObj = { name, list };
  }

  buildAvailabilityFromFilters() {
    const miniAvailabilityData: AvailabilityOnCreateModel = {};
    if (this.filterItems.service && this.filterItems.service.length > 0) {
      miniAvailabilityData.service = {
        key: this.filterItems.service[0],
        value: this.getServiceById(this.filterItems.service[0]).name
      };
    }

    if (this.filterItems.name && this.filterItems.name.length > 0) {
      miniAvailabilityData.name = {
        key: this.filterItems.name[0],
        value: this.getAvailabilityTemplateById(this.filterItems.name[0]).name
      };
    }

    if (this.filterItems.status && this.filterItems.status.length > 0) {
      miniAvailabilityData.status = {
        key: this.filterItems.status[0]
      };
    }

    if (this.filterItems.campus && this.filterItems.campus.length > 0) {
      miniAvailabilityData.campus = {
        key: this.filterItems.campus[0]
      };
    }

    if (this.filterItems.space && this.filterItems.space.length > 0) {
      miniAvailabilityData.space = {
        key: this.filterItems.space[0]
      };
    }

    if (
      this.filterItems.responsable &&
      this.filterItems.responsable.length > 0
    ) {
      miniAvailabilityData.responsable = {
        key: this.filterItems.responsable[0]
      };

      miniAvailabilityData.dependency = {
        key: this.getResponsableById(this.filterItems.responsable[0]).extra
      };
    }

    return miniAvailabilityData;
  }

  async getAvailabilityTemplates(availabilityName = "") {
    const nameFilter = this.filterArray[0].secondaryFilters.find(
      item => item.key == AVAILABILITY_FILTERS_NAME.NAME
    ) as SecondaryFilter;

    nameFilter.loadingData = true;

    if (availabilityName !== this.keyWordAvailabiltyName) {
      this.lastAvailabilityRef = "";
    }

    this.keyWordAvailabiltyName = availabilityName ?? "";

    try {
      const response = await this.availabilityTemplateService.getAvailabitiesTemplate(
        this.lastAvailabilityRef,
        availabilityName ?? ""
      );

      this.lastAvailabilityRef = response.data?.lastReference ?? "";

      if (response.code == Http.Found && response.data != undefined) {
        const availabilityTemplates = response.data.availabilitiesTemplates;
        const availabilityTemplatesList: List[] = [];

        availabilityTemplates.forEach(({ id, name }) => {
          availabilityTemplatesList.push({
            key: id as string,
            name: name
          });
        });

        if (this.lastAvailabilityRef) {
          this.listOfAvailabilityTemplates = [
            ...this.listOfAvailabilityTemplates,
            ...availabilityTemplatesList
          ];
        } else {
          this.listOfAvailabilityTemplates = availabilityTemplatesList;
        }

        this.setList(
          AVAILABILITY_FILTERS_NAME.NAME,
          this.listOfAvailabilityTemplates
        );

        this.lastAvailabilityRef = response.data.lastReference;
      } else {
        this.lastAvailabilityRef = "";
        Snackbar.popInfo(response.message);
      }
      nameFilter.loadingData = false;
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      nameFilter.loadingData = false;
    }
  }

  async getServiceNames() {
    try {
      const response = await this.availabilityService.getAvailabilityNames();

      if (response.code == Http.Found && response.data) {
        const availabilityNamesList: List[] = response.data;
        this.listOfNames = availabilityNamesList;
        this.setList(AVAILABILITY_FILTERS_NAME.NAME, availabilityNamesList);
      }
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getServiceTemplates() {
    try {
      const response = await this.serviceTemplateService.getAllActiveServiceTemplate(
        STATE.ACTIVE
      );

      if (response.code === Http.Found && response.data) {
        const serviceTemplates = response.data;
        const serviceTemplatesList: List[] = [];

        serviceTemplates.forEach(({ id, internalName }) => {
          serviceTemplatesList.push({
            key: id as string,
            name: internalName
          });
        });
        this.listOfServiceTemplates = serviceTemplatesList;
        this.setList(AVAILABILITY_FILTERS_NAME.SERVICE, serviceTemplatesList);
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + SERVICE_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getSpaces() {
    try {
      const response = await this.spaceService.getAllSpaces();
      if (response.code === Http.Found && response.data) {
        const spaces = response.data;
        const spacesList: List[] = [];
        let filtered = [...spaces];
        if (this.availabilityInfo.spaces.length > 0) {
          filtered = spaces.filter(e =>
            this.availabilityInfo.spaces.includes(e.key)
          );
        }
        if (this.filterItems.campus && this.filterItems.campus.length > 0) {
          filtered = filtered.filter(
            e => e.campus && this.filterItems.campus.includes(e.campus)
          );
        }
        filtered.forEach(({ key, name, campus }) => {
          const campusFound = this.listOfCampuses.find(e => e.key == campus);
          const campusName = campusFound?.name ? `(${campusFound?.name})` : "";
          spacesList.push({ key, name: `${name} ${campusName}`.trim() });
        });
        this.listOfSpaces = [...spacesList];
        await this.setList(AVAILABILITY_FILTERS_NAME.SPACE, this.listOfSpaces);
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + SPACES_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getCampus() {
    try {
      const response = await this.campusService.getAllCampus();
      if (response.code === Http.Found && response.data) {
        const campus = response.data;
        const campusList: List[] = [];
        let filtered = [...campus];
        if (this.availabilityInfo.campuses.length > 0) {
          filtered = campus.filter(e =>
            this.availabilityInfo.campuses.includes(e.key)
          );
        }
        filtered.forEach(({ key, name }) => {
          campusList.push({ key, name });
        });
        this.listOfCampuses = campusList;
        await this.setList(
          AVAILABILITY_FILTERS_NAME.CAMPUS,
          this.listOfCampuses
        );
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + CAMPUS_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getResponsables() {
    try {
      const response = await this.userService.getAllResponsables();
      if (response.code === Http.Found && response.data) {
        const data = response.data;
        const usersList: List[] = [];
        let filtered = [...data];
        if (this.availabilityInfo.responsables.length > 0) {
          filtered = data.filter(e =>
            this.availabilityInfo.responsables.includes(e.key)
          );
        }
        filtered.forEach(({ dependency, key, name }) => {
          usersList.push({
            extra: dependency,
            key,
            name
          });
        });
        this.listOfUsers = usersList;
        this.setList(AVAILABILITY_FILTERS_NAME.RESPONSABLE, this.listOfUsers);
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + USER_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  getServiceById(id: string) {
    const response = this.listOfServiceTemplates.filter(
      data => data.key === id
    )[0];
    return response;
  }

  getResponsableById(id: string) {
    return this.listOfUsers.filter(data => data.key === id)[0];
  }

  getAvailabilityTemplateById(id: string) {
    const response = this.listOfAvailabilityTemplates.filter(
      data => data.key === id
    )[0];
    return response;
  }

  availabilityTemplateModal(item: SecondaryFilterOptions) {
    this.currentAvailabilityItem = item;
    this.showEditAvailabilityName = true;
  }

  closeEditAvailabilityName() {
    this.currentAvailabilityItem = {} as SecondaryFilterOptions;
    this.showEditAvailabilityName = false;
  }
  closeViewTemplate() {
    this.viewTemplateSelected = {} as SecondaryFilterOptions;
    this.showViewTemplate = false;
  }

  async editAvailabilityName(item: SecondaryFilterOptions) {
    try {
      const availabilityTemplate: AvailabilityTemplate = {
        id: item.key,
        name: item.name,
        dateChanged: Date.now()
      };
      const response = await this.availabilityTemplateService.saveAvailabilityTemplate(
        availabilityTemplate
      );

      if (response.code === Http.Ok) {
        Snackbar.popInfo(response.message);
        this.getAvailabilityTemplates();
        this.lastReference = "";
        this.filterAvailabilitiesTemplates(this.filterPanel, false);
        this.closeEditAvailabilityName();
        await this.getEvents(this.calendarPerspective);
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async emitSearchInitializer() {
    // await this.getServiceTemplates();
    const filterArray = lodash.cloneDeep(CONTEXT_PANEL_FILTERS_LIST);
    // filterArray[0].secondaryFilters[1].options = this.listOfServiceTemplates;

    const searchContext: SearchContext = {
      title: this.TITLE,
      filterArray: filterArray,
      operations: this.OPERATIONS,
      clickAction: LIST_DATA_EVENTS.ON_CLICK,
      callbackHandleOperation: this.handleOperation,
      componentName: COMPONENT_NAME_MODAL.AVAILABILITY,
      descriptions: [AVAILABILITY_FILTERS_NAME.STATUS],
      textButtonCreate: this.CREATE_BUTTON
    };
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SEARCH_CONTEXT,
      searchContext
    );
    this.filterAvailabilitiesTemplates({}, false);
  }

  async handleOperation(
    action: string,
    itemId: string,
    state: string,
    name: string
  ) {
    const item: SecondaryFilterOptions = { key: itemId, name };
    switch (action) {
      case LIST_DATA_EVENTS.VIEW_DATA:
        this.getAvailabityTemplateById(itemId);
        break;
      case LIST_DATA_EVENTS.EDIT_DATA:
        this.availabilityTemplateModal(item);
        break;
      case LIST_DATA_EVENTS.DELETE_DATA:
        this.deleteAvailabilityTemplate(itemId);
        break;
      case LIST_DATA_EVENTS.ON_CLICK:
        this.getFilteredEvents({ name: [itemId] });
        break;
    }
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  sendDataToLateralMenu(action: string, data?: any) {
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.CRUD,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: action,
      data: data
    });
  }

  @Watch("dataToMainView")
  handleDataToMainView() {
    if (
      this.dataToMainView.from === PANEL_INFO_CONSTANTS.FROM.PANEL &&
      this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.SEARCH
    ) {
      switch (this.dataToMainView.action) {
        case PANEL_INFO_CONSTANTS.ACTION.DO_SEARCH_TEMPLATE:
          this.lastReference = "";
          this.filterPanelArray = this.dataToMainView.data;
          // eslint-disable-next-line no-case-declarations
          this.filterPanel = {};
          if (this.dataToMainView.data.name)
            this.filterPanel.name = this.dataToMainView.data.name[0];
          if (this.dataToMainView.data.service)
            this.filterPanel.service = this.dataToMainView.data.service[0];
          this.filterAvailabilitiesTemplates(this.filterPanel, false);
          break;
        case PANEL_INFO_CONSTANTS.ACTION.DO_ON_BOTTOM_CONTEXT:
          if (!this.loadingData)
            this.filterAvailabilitiesTemplates(this.filterPanel, true);
          break;
      }
    }
  }

  async filterAvailabilitiesTemplates(
    filter: AvailabilityTemplateFilter,
    shouldPaginate: boolean
  ) {
    try {
      this.loadingData = true;
      if (this.lastReference && shouldPaginate)
        filter.idReference = this.lastReference;
      else delete filter.idReference;
      const response = await this.availabilityTemplateService.filterAvailabitiesTemplate(
        filter
      );

      if (response.code == Http.Found && response.data) {
        const templateList = response.data.availabilitiesTemplates;
        this.lastReference = response.data.lastReference;
        if (shouldPaginate) {
          this.listAvailabilityTemplates = [
            ...this.listAvailabilityTemplates,
            ...templateList
          ];
        } else this.listAvailabilityTemplates = templateList;

        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
          this.listAvailabilityTemplates
        );
      } else {
        if (!shouldPaginate) {
          this.listAvailabilityTemplates = [];
        }
      }
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
    this.loadingData = false;
  }
  async getAvailabityTemplateById(templateId: string) {
    try {
      const response = await this.availabilityTemplateService.getAvailabityTemplateById(
        templateId
      );

      if (response.code == Http.Found && response.data) {
        this.viewTemplateSelected = response.data;
        this.showViewTemplate = true;
      }
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }
  async deleteAvailabilityTemplate(templateId: string) {
    try {
      const response = await this.availabilityTemplateService.deleteAvailabilityTemplate(
        templateId
      );

      if (response.code == Http.Ok) {
        this.lastReference = "";
        await this.filterAvailabilitiesTemplates(this.filterPanel, false);
      }

      Snackbar.popInfo(response.message);
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  @Watch("filterItems.campus")
  async onChangeCampus() {
    if (this.events.length > 0) {
      await this.getSpaces();
    }
  }

  @Watch("filterItems.space")
  async onChangeSpace() {
    if (this.events.length > 0) {
      await this.getResponsables();
    }
  }

  async getServicesByAvailabilityId(templateId: string) {
    try {
      const response = await this.availabilityTemplateService.getAvailabityTemplateById(
        templateId
      );

      if (response.code == Http.Found && response.data) {
        if (!response.data?.services) {
          this.listOfServiceTemplates = [];
          return;
        }
        this.listOfServiceTemplates = response.data?.services?.map(e => {
          return {
            key: e.id,
            name: e.name
          };
        });
        this.setList(
          AVAILABILITY_FILTERS_NAME.SERVICE,
          this.listOfServiceTemplates
        );
        return;
      }
      this.listOfServiceTemplates = [];
      return;
    } catch (error) {
      return [];
    }
  }

  async resetFilters() {
    this.availabilityInfo = {
      spaces: [],
      campuses: [],
      responsables: []
    };
    this.listOfServiceTemplates = [];
    await this.setList(
      AVAILABILITY_FILTERS_NAME.SERVICE,
      this.listOfServiceTemplates
    );
    this.listOfSpaces = [];
    await this.setList(AVAILABILITY_FILTERS_NAME.SPACE, this.listOfSpaces);
    this.listOfCampuses = [];
    await this.setList(AVAILABILITY_FILTERS_NAME.CAMPUS, this.listOfCampuses);
    this.listOfResponsables = [];
    await this.setList(
      AVAILABILITY_FILTERS_NAME.RESPONSABLE,
      this.listOfResponsables
    );
  }

  @Watch("events")
  async onChangeEvents() {
    this.totalEventsLocal = this.events.reduce(
      (sum, event) => sum + Number(event.total),
      0
    );
    this.totalEventsReservedLocal = this.events.reduce(
      (sum, event) => sum + Number(event.reserved),
      0
    );
  }

  async loadConstantsUi() {
    try {
      if (!this.$store.state.constantsUI.availabilities) {
        await this.$store.dispatch(STORE_CONSTANTS.FETCH_CONSTANTS_UI);
      }
      const CONSTANTS_UI = this.$store.state.constantsUI;

      const { labels: commonLabels } = CONSTANTS_UI.common;
      const { labels: availabilityLabels } = CONSTANTS_UI.availabilities;

      const labelMappings = {
        PAGE_START: commonLabels.GO_START,
        CANCEL_BUTTON: commonLabels.CANCEL,
        EDIT_BUTTON: commonLabels.EDIT,
        DELETE_BUTTON: commonLabels.DELETE,
        CLOSE_BUTTON: commonLabels.CLOSE,
        GOBACK_BUTTON: commonLabels.GO_BACK,
        TITLE: availabilityLabels.TITLE,
        CREATE_BUTTON: availabilityLabels.CREATE_BUTTON,
        UPLOAD_BUTTON: availabilityLabels.UPLOAD_BUTTON,
        MORE_TEXT: availabilityLabels.MORE_TEXT,
        SPACES_RESERVED: availabilityLabels.SPACES_RESERVED
      };

      Object.keys(labelMappings).forEach(key => {
        (this as any)[key] = (labelMappings as any)[key];
      });
    } catch (error) {
      console.error("Error al consultar labels");
    }
  }
}
